import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ValidationInput, ValidationDropDownValueList } from '../Form/validation';

/**
 * used as the template of cell in list view during inline edit
 * @param {any} props contains title, editable, children, dataIndex, record, valueList, maxLength, dropdownStyle, onChangeData, editingRecord, setEditingRecord, required, customRenderer, readOnly
 */
const EditableCell = (props) => {
    const { title, editable, children, dataIndex, record, valuelist, additionalData, disableCach, maxLength, dropdownStyle, onChangeData, editingRecord, setEditingRecord, customRenderer, readOnly, validation, ...restProps } = props;
    const [editing, setEditing] = useState(false);
    /**const form = useContext(EditableContext);*/
    const isRowEditing = editingRecord?.ID && editingRecord.ID === record.ID;
    const toggleEdit = () => {
        if (!isRowEditing) {
            setEditing(!editing);

            /** //form.setFieldsValue({
            * //    [dataIndex]: record[dataIndex],
            //}); */
            setEditingRecord({
                ...editingRecord,
                [dataIndex]: record[dataIndex],
            });
        }
    };

    const save = async (e, editMode) => {
        /** const values = await form.validateFields();*/
        editMode || toggleEdit();
        if (onChangeData) {
            onChangeData({
                ...(editingRecord?.ID ? editingRecord : record)
            });
        }
    };

    const onChange = (e) => {
        if (isRowEditing) {
            setEditingRecord({ ...editingRecord, [dataIndex]: e.target ? e.target.value : e });
        }
    }

    let childNode = children;
    if (editable || (isRowEditing && !readOnly)) {
        let optionsProps = null;
        if (valuelist) {
            optionsProps = valuelist.map ? { items: valuelist.map((item, i) => ({ text: item.text, value: item.value })) } : { valuelist, additionalData, disableCach };
        }
        childNode = editing || isRowEditing ? (
            <wrap>
                {
                    valuelist ?
                        (
                            <ValidationDropDownValueList
                                validation={validation}
                                name={dataIndex}
                                value={editingRecord[dataIndex]}
                                onBlur={save}
                                onChange={editable ? (e) => { save(e, true); } : onChange}
                                {...optionsProps}
                                style={{ width: '100%', height: '100%' }}
                                {...(dropdownStyle ? { dropdownStyle: dropdownStyle } : {})}
                            />
                        ) : (
                            customRenderer ? customRenderer({ ...props, onChange, editingRecord, setEditingRecord, validation })
                            : <ValidationInput 
                                    validation={validation} 
                                    type='text' 
                                    value={editingRecord[dataIndex]} 
                                    onKeyPress={(event) => {
                                        if (event.key === "Enter") {
                                            save();
                                        }
                                    }} 
                                    onBlur={save} 
                                    maxLength={maxLength} 
                                    name={dataIndex} 
                                    onChange={onChange}
                                    className={'ant-input'} 
                                />
                        )
                }
            </wrap>
        ) : (<wrap onClick={toggleEdit}> <text>{children}</text></wrap>);
    }

    return <td {...restProps} > {childNode}</td >;
};

EditableCell.propTypes = {
    title: PropTypes.string,
    editable: PropTypes.bool,
    children: PropTypes.node,
    dataIndex: PropTypes.string.isRequired,
    record: PropTypes.object.isRequired,
    valuelist: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    additionalData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disableCach: PropTypes.bool,
    maxLength: PropTypes.number,
    dropdownStyle: PropTypes.object,
    onChangeData: PropTypes.func,
    editingRecord: PropTypes.object,
    setEditingRecord: PropTypes.func,
    customRenderer: PropTypes.func,
    readOnly: PropTypes.bool,
    validation: PropTypes.object
};

export default EditableCell;